import { parseQuery } from '@calendly/http-tools'


export const buildGuests = () => {
  const query = parseQuery(window.location.search)
  return query.guests?.split(',').filter((item) => item !== '') || []
}
